export default "__VITE_ASSET__c8eb5ZuW__"